<template>
  <section class="section-main">
    <div class="section-main__content">
      <inline-svg :src="require('../../assets/icon/svg/card-fail.svg')" />
      <div class="section-main__title">
        <h1 class="fail">付款失敗</h1>
      </div>
      <p>請重新連線</p>
    </div>
    <div class="section-main__action">
      <button
        class="button is-fullwidth is-fill is-rounded"
        @click="handleClick()"
        type="button"
      >
        回到首頁
      </button>
    </div>
  </section>
</template>
<script>
export default {
  name: "CardAuthFailedMessage.",
  methods: {
    handleClick() {
      this.$router.push({
        name: "ConnectorSearch",
      });
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  created() {
    this.scrollToTop();
  },
};
</script>
